import React from 'react';
import { CurrencyProvider } from '../store/currencyContext';
import CurrencyList from '../components/Currency/CurrencyList';
import { ProductProvider } from '../store/productContext';

const CurrencyPage: React.FC = () => (
    <CurrencyProvider>
        <ProductProvider>
            <CurrencyList />
        </ProductProvider>
    </CurrencyProvider>
);

export default CurrencyPage;
